import { msg } from "@lingui/core/macro";

export const expiresNeverRuleMessages = {
	name: msg({
		message: "Never Expires",
		comment: "Name of the permit type rule under which Permits have no end date and stay valid indefinitely",
	}),
	description: msg({ message: "Permits never expire" }),
	errors: {
		hasEndTime: msg({
			message: "Permit must not have an end time because it never expires",
			comment:
				"Error when a Permit is created or edited with an end time on a parking option set to Never Expires",
		}),
	},
} as const;
